/**
 * Fallback color values for ECharts canvas rendering.
 * Used when design token CSS variables have not yet resolved.
 */
export const CHART_FALLBACK_COLORS = {
  tooltipBackground: '#fff',
  tooltipText: '#333',
  axisLine: '#e0e0e0',
  axisLabel: '#666',
  legendText: '#666',
} as const;
